import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

import { computed, onMounted, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import { InputTsx, SelectTsx, TextareaTsx } from './components/indext'

/**
 * 将submit的提交抛出去
 */
export interface FormItemProps {
  rules?: {required: boolean, message: string} | boolean,
  type: COMMON.COMPONENTS.ComType,
  key: string,
  value?: any,
  label: string,
  request?: () => Promise<{
    name: string,
    value: any,
    key: string
  }[]>
}

/**
* 直接将table的columns传入时进行数据转化处理
 */
export interface ColumnsProps {
  title: string,
  dataIndex: string,
  key?: string,
  formProps?: FormItemProps
}

export interface FormProProps {
  labelCol: any
  reset?: boolean // 是否开启一键reset表单
  search?: boolean // 是否开启搜索功能
  validate: boolean // 是否开启验证功能
  layout?: 'horizontal' | 'vertical' | 'inline', // 布局方式 默认横向布局
  itemWidth: string // 每个表单控件的长度
  formProps?: FormItemProps[] // 表单props
  columnsProps?: ColumnsProps[] // 与table表格一起传入的时候, 便于从table表格中筛选
  [key: string]: any
}

enum ComponentTypeEnum {
  'input' = 'input',
  'select' = 'select'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    labelCol: {},
    reset: { type: Boolean },
    search: { type: Boolean },
    validate: { type: Boolean },
    layout: {},
    itemWidth: {},
    formProps: {},
    columnsProps: {}
  },
  emits: ['submit', 'reset', 'search'],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const componentTypes: COMMON.COMPONENTS.ComType[] = ['input', 'select', 'datepick']

const formItemLayout = computed(() => {
  return propsState.layout === 'horizontal'
    ? {
        labelCol: props.labelCol ? props.labelCol : { span: 4 },
        wrapperCol: { span: 14 }
      }
    : {}
})

const getLablePrefix = (key: COMMON.COMPONENTS.ComType) => {
  switch (key) {
    case 'input':
      return '请填写'
    case 'select':
      return '请选择'
    default:
      return '请填写'
  }
}

const useForm = Form.useForm





const propsState = reactive({
  layout: 'horizontal'
})

const initFormPro = () => {
  if (props.formProps) {
    props.formProps.forEach((item: FormItemProps) => {
      const key = item.key
      rulesRef[key] = typeof item.rules === 'object' ? item.rules : [{ required: item.rules, message: getLablePrefix(item.type) + item.label }]
      modelRef[key] = item.value || ''
      formProps.push({ ...item })
    })
  } else {
    props.columnsProps.forEach((item: ColumnsProps) => {
      if (item.formProps) {
        const key = item.formProps!.key ? item.formProps!.key : item.dataIndex
        const rules = typeof item.formProps!.rules === 'object'
          ? item.formProps!.rules
          : [{ required: item.formProps!.rules, message: getLablePrefix(item.formProps.type) + item.title }]

        rulesRef[key!] = rules
        modelRef[item.formProps.key] = item.formProps.value || ''
        formProps.push({ ...item.formProps })
      }
    })
  }

  propsState.layout = props.layout ? props.layout : 'horizontal'
}

const modelRef = reactive<Record<string, any>>({})

const rulesRef = reactive<Record<string, any>>({})

const formProps = reactive<FormItemProps[]>([])

const onChange = (record: any, key: string) => {
  modelRef[key] = record
}

const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)

const search = async () => {
  const r = await onSubmit()
  emit('search', r)
}

const onSubmit = () => {
  return new Promise((resolve, reject) => {
    validate()
      .then(() => {
        resolve(modelRef)
      })
      .catch(err => {
        reject(err)
      })
  })
}

__expose({
  onSubmit
})

onMounted(() => {
  initFormPro()
})


return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, _mergeProps(formItemLayout.value, {
    layout: props.layout,
    autocomp: "",
    lete: "off"
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formProps, (item) => {
        return (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
          key: item.key,
          label: item.label
        }, _unref(validateInfos)[item.key]), {
          default: _withCtx(() => [
            (item.type === 'input')
              ? (_openBlock(), _createBlock(_unref(InputTsx), {
                  key: 0,
                  style: _normalizeStyle({width: props.itemWidth ? props.itemWidth : null}),
                  modelValue: modelRef[item.key],
                  "onUpdate:modelValue": ($event: any) => ((modelRef[item.key]) = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]))
              : (item.type === 'select')
                ? (_openBlock(), _createBlock(_unref(SelectTsx), {
                    key: 1,
                    style: _normalizeStyle({width: props.itemWidth}),
                    request: item.request,
                    modelValue: modelRef[item.key],
                    "onUpdate:modelValue": ($event: any) => ((modelRef[item.key]) = $event),
                    "on-change": (e) => onChange(e, item.key)
                  }, null, 8, ["style", "request", "modelValue", "onUpdate:modelValue", "on-change"]))
                : (item.type === 'textarea')
                  ? (_openBlock(), _createBlock(_unref(TextareaTsx), {
                      key: 2,
                      style: _normalizeStyle({width: props.itemWidth ? props.itemWidth : null}),
                      modelValue: modelRef[item.key],
                      "onUpdate:modelValue": ($event: any) => ((modelRef[item.key]) = $event)
                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040, ["label"]))
      }), 128)),
      (props.search)
        ? (_openBlock(), _createBlock(_component_a_form_item, { key: 0 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "search", {}, () => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["layout"]))
}
}

})